function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import './LinkButton.css';
import cs from 'classnames';
import { Link } from 'react-router-dom';
import whitelistProps from '../../utils/whitelistProps';
import ButtonWrapper from '../ButtonWrapper/ButtonWrapper';
import ThemeContext from '../../ThemeContext';
import { useCallback, useContext, useRef } from 'react';
var whitelist = whitelistProps('onBlur', 'onFocus', 'onMouseOver', 'onMouseOut', 'onKeyDown');
/**
 * Link container styled as a button.
 * >
 * > * @param {object} props React component properties
 * > * @param {string} props.className custom CSS classes to add
 * > * @param {boolean} props.disabled affects style and prevents onClick handler
 * > * @param {string} props.to href to link to
 */
export function LinkButton(_ref2, ref) {
  var children = _ref2.children,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? '' : _ref2$className,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    describedby = _ref2.describedby,
    to = _ref2.to,
    onClick = _ref2.onClick,
    _ref2$target = _ref2.target,
    target = _ref2$target === void 0 ? '_self' : _ref2$target,
    _ref2$modifier = _ref2.modifier,
    modifier = _ref2$modifier === void 0 ? 'basic' : _ref2$modifier,
    attrs = _objectWithoutProperties(_ref2, ["children", "className", "disabled", "describedby", "to", "onClick", "target", "modifier"]);
  var handleClick = React.useCallback(function (e) {
    if (disabled) {
      e.preventDefault();
    } else {
      onClick && onClick(e);
    }
  }, [disabled, onClick]);
  var defaultRef = useRef();
  var _ref = ref || defaultRef;
  var handleKeyPress = useCallback(function (event) {
    if (event.key == ' ' || event.keyCode == 32
    // event.code == "Space" || //can use in react version 17+
    ) {
      event.preventDefault();
      //@ts-ignore
      _ref.current.click();
    }
  }, [_ref]);
  var theme = useContext(ThemeContext);
  var onKeyDownEvent = attrs.onKeyDown,
    props = _objectWithoutProperties(attrs, ["onKeyDown"]);
  return /*#__PURE__*/React.createElement(Link
  //@ts-ignore
  , Object.assign({
    ref: _ref,
    to: to,
    target: target,
    className: cs("_dm-button _dm-button--link auto-link-button", _defineProperty(_defineProperty(_defineProperty({}, className, className), '_dm-button--disabled', disabled), '_dm-button--enabled', !disabled), _defineProperty({}, "_dm-button--".concat(theme), theme)),
    "aria-describedby": describedby,
    onClick: handleClick,
    "aria-disabled": disabled,
    onKeyDown: handleKeyPress
  }, whitelist(props)), /*#__PURE__*/React.createElement(ButtonWrapper, {
    disabled: disabled,
    modifier: modifier
  }, children));
}
var Component = React.forwardRef(LinkButton);
Component.displayName = 'LinkButton';
export default Component;